<template>
    <div class="body d-flex py-lg-3 py-md-2">
        <div class="container-xxl">
            <div class="row clearfix">
                <div class="col-md-12">
                    <div class="col-md-12 d-flex">
                        <!-- Main Content (Table/Grid) -->
                        <div :class="{ 'col-md-12': !showFilters, 'col-md-9 leftCol': showFilters }">
                            <div v-if="!isGridView" class="card-body table-responsive">
                                <table id="projectTable" class="table table-hover align-middle mb-0 mis_table"
                                    style="width:100%">
                                    <thead>
                                        <tr>
                                            <th style="width:10%;">
                                                <div>Title<i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('projects.description')"></i></div>
                                            </th>
                                           <th style="width:5%;">
  <div v-if="superUser" class="d-flex align-items-center">
    <!-- Custom Dropdown for Creators -->
    <div class="custom-dropdown">
      <!-- Dropdown Button -->
      <div class="dropdown-btn" @click="toggleDropdownCreator">
        <span>{{ selectedCreator || 'Επιλογη Creator' }}</span>
        <i class="icofont-rounded-down"></i>
      </div>

      <!-- Dropdown Options -->
      <ul v-if="isDropdownCreatorOpen" class="dropdown-options">
        <li @click="selectCreator({ id: null, username: 'All Creators' })">
          All Creators
          <img
            src="../assets/images/icons8-superman.svg"
            alt="Citrine Logo"
            class="menu-img ms-2"
            style="width: 1.5em"
          />
        </li>
        <li
          v-for="creator in creators"
          :key="creator.id"
          @click="selectCreator(creator)"
        >
          {{ creator.username }}
          <img
            v-if="String(creator.id) !== currentUserId()"
            src="../assets/images/icons8-superman.svg"
            alt="Superman Icon"
            class="menu-img ms-2"
            style="width: 1.5em"
          />
        </li>
      </ul>
    </div>
  </div>

  <div v-else>
    Creator
    <i class="fa fa-sort sorting-icon" @click.prevent="sortBy('c.username')"></i>
  </div>
</th>



                                           <th style="width:5%;">
                        <div v-if="superUser" class="d-flex align-items-center">
                      
                          <div class="custom-dropdown">
                            <div class="dropdown-btn" @click="toggleDropdown">
                              <span>{{ selectedManager || 'Επιλογη Manager' }}</span>
                              <i class="icofont-rounded-down"></i>
                            </div>
                            <ul v-if="isDropdownOpen" class="dropdown-options">
                             <li @click="selectManager({ id: null, username: 'All Managers' })">
                                All Managers <img src="../assets/images/icons8-superman.svg" alt="Citrine Logo" class="menu-img ms-2"
                            style="width:2em">
                              </li>
                             <li
  v-for="manager in managers"
  :key="manager.id"
  @click="selectManager(manager)"
>
  {{ manager.username }}
  
  <!-- Show superman icon unless it's the current user -->
  <img
    v-if="String(manager.id) !== currentUserId()"
    src="../assets/images/icons8-superman.svg"
    alt="Superman Icon"
    class="menu-img ms-2"
    style="width: 1.5em"
  />
</li>
                            </ul>
                          </div>
                        
                        </div>
                        <div v-else>
                          Manager
                          <i class="fa fa-sort sorting-icon" @click.prevent="sortBy('m.username')"></i>
                        </div>
                      </th>
                                            <th style="width:8%;">
                                                <div>Payable<i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('projects.payable')"></i></div>
                                            </th>
                                            <th style="width:8%;">
                                                <div>Paid<i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('projects.paid')"></i></div>
                                            </th>
                                            <th style="width:10%;">
                                                <div>Invoiced<i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('projects.invoiced')"></i></div>
                                            </th>
                                            <th style="width:10%;">
                                                <div>Sub/tion date<i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('projects.subscriptionDate')"></i></div>
                                            </th>
                                            <th style="width:12%;">
                                                <div>Sub/tion duration<i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('projects.subscriptionDuration')"></i>
                                                </div>
                                            </th>
                                            <th style="width:10%;">
                                                <div>Status</div>
                                            </th>
                                            <th class="no-after"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(project, index) in data" :key="project.info.id"
                                           
                                            @click="toggleProjectSelection(project.info.id, $event)">
                                            <td>
                                                <router-link :to="{ path: 'project', query: { id: project.info?.id } }">
                                                    <span class="project-code">{{ project.info?.code }}</span>
                                                </router-link>
                                            </td>
                                            <td v-if="project.creator?.avatar_file_name" class="small-column">
                                                <img :src="`/storage/avatars/${project.creator.avatar_file_name}`"
                                                    width="30" style="border-radius:50%;" :title="project.creator.username" class="managerProfIcon">
                                            </td>
                                            <td v-else class="small-column">
                                                {{ project.creator?.username }}
                                            </td>
                                            <td v-if="project.manager?.avatar_file_name" class="small-column">
                                                <img :src="`/storage/avatars/${project.manager.avatar_file_name}`"
                                                    width="30" style="border-radius:50%;" :title="project.manager.username" class="managerProfIcon">
                                            </td>
                                            <td v-if="!project.manager?.avatar_file_name" class="small-column">
                                                {{ project.manager?.username }}
                                            </td>                                            <td>{{ project.info?.payable === 1 ? 'Yes' : 'No' }}</td>
                                            <!-- Conditional display -->
                                            <td>{{ project.info?.paid === 1 ? 'Yes' : 'No' }}</td>
                                            <td>{{ project.info?.invoiced === 1 ? 'Yes' : 'No' }}</td>
                                            <td>{{ project?.subscriptionDate_formatted }}</td>
                                            <td>{{ project.info?.subscriptionDuration }}</td>
                                            <td>
                                                <span
                                                    :style="getStatusStyle(getStatusText(project.info.subscriptionDate, project.info.subscriptionDuration))"
                                                    style="display:unset;">{{
                                                        getStatusText(project.info.subscriptionDate, project.info.subscriptionDuration) }}</span>

                                            </td>
                                            <td>
                                                <div class="button-group">
                                                    <div class="icon-wrapper">
                                                        <button class="btn btn-dark">
                                                            <i class="wx-ic wx-ic-chat" title="Unread comments"></i>
                                                            <span class="unread-comments"
                                                                v-if="project.unread_comments > 0">{{
                                                                project.unread_comments }}</span>
                                                        </button>
                                                    </div>
                                                    
                                                    <div class="icon-wrapper">
                                                        <button class="btn btn-dark"
                                                            @click.prevent="archiveProject(project.info.id)"
                                                            v-if="canArchive || superUser">
                                                            <i class="wx-ic wx-ic-trash" title="Archive"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>

                                        </tr>
                                        <tr class="col" v-if="!data || !data.length">
                                            <td colspan="100">No data</td>

                                        </tr>
                                    </tbody>
                                </table>
                                <nav aria-label="Page navigation">
                                    <ul class="pagination mt-4" v-if="paginationLinks && paginationLinks.length > 0">
                                        <li class="page-item" v-for="(paginationLink, index) in paginationLinks"
                                            :key="index" :class="{ active: paginationLink.active }">
                                            <router-link
                                                :to="{ path: 'hosting', query: { ...filters, page: getPageFromUrl(paginationLink.url) } }"
                                                v-if="paginationLink.url">
                                                <span class="page-link" v-html="paginationLink.label"></span>
                                            </router-link>
                                            <span class="page-link" v-else v-html="paginationLink.label"></span>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                            <div v-if="isGridView" class="row g-3">
                                <div v-for="(project, index) in data" :key="project.info.id"
                                    class="col-md-4 col-sm-6 mb-2">
                                    <div class="card h-100"
                                        style="border-radius: 15px; margin-left:1em; background: #eae8e8; color: black;">
                                        <div class="card-body position-relative">
                                            <!-- Header Section -->
                                            <div class="d-flex align-items-center mb-3">
                                                <div class="ms-3"
                                                    style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
                                                    <router-link
                                                        :to="{ path: 'project', query: { id: project.info?.id } }">

                                                        <h6 class="mb-0 mt-2 fw-bold">{{ project.info?.code }}</h6>
                                                    </router-link>
                                                    <span class="d-block small-14 mb-0">{{ project.client?.title
                                                        }}</span>
                                                </div>
                                            </div>

                                            <div class="d-flex d-column">
                                                <div style="width:60%">
                                                    <!-- Creator and Manager -->
                                                    <div class="d-flex align-items-center mb-2">
                                                        <span class="me-2 fw-bold">Creator:</span>
                                                        <img v-if="project.creator?.avatar_file_name"
                                                            :src="`/storage/avatars/${project.creator.avatar_file_name}`"
                                                            width="30" style="border-radius: 50%" :title="project.creator.username">
                                                        <span v-else>{{ project.creator?.username }}</span>
                                                    </div>
                                                    <div class="d-flex align-items-center mb-2">
                                                        <span class="me-2 fw-bold">Manager:</span>
                                                        <img v-if="project.manager?.avatar_file_name"
                                                            :src="`/storage/avatars/${project.manager.avatar_file_name}`"
                                                            width="30" style="border-radius: 50%" :title="project.manager.username">
                                                        <span v-else>{{ project.manager?.username }}</span>
                                                    </div>
                                                    <div class="mb-2">
                                                        <span class="fw-bold">Invoiced: {{ project.info?.invoiced === 1 ? 'Yes' : 'No' }}</span> 
                                                    </div>
                                                    <div class="mb-2">
                                                        <span class="fw-bold">Payable: {{ project.info?.payable === 1 ? 'Yes' : 'No' }}</span> 
                                                    </div>
                                                    <div class="mb-2">
                                                        <span class="fw-bold">Paid: {{ project.info?.paid === 1 ? 'Yes' : 'No' }}</span> 
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="mb-2">
                                                        <span class="fw-bold"><i class="wx-ic wx-ic-calendar" title="Edit"></i>Subscription date: {{ project?.subscriptionDate_formatted }}</span> 
                                                    </div>
                                                    <div class="mb-2">
                                                        <span class="fw-bold"><i class="icofont-clock-time"></i>Subscription duration: {{ project.info?.subscriptionDuration }}</span> 
                                                    </div>  
                                                </div>
                                            </div>

                                            <!-- Action Buttons -->
                                            <div class="action-buttons">
                                                <button class="btn btn-dark">
                                                    <i class="wx-ic wx-ic-chat" title="Unread comments"></i>
                                                    <span class="unread-comments"
                                                        v-if="project.unread_comments > 0">{{
                                                        project.unread_comments }}</span>
                                                </button>
                                                
                                                <button class="btn btn-dark delete"
                                                    @click.prevent="archiveProject(project.info.id)"
                                                    v-if="canArchive || superUser">
                                                    <i class="wx-ic wx-ic-trash" title="Archive"></i>
                                                </button>
                                            </div>

                                            <!-- Status Dropdown -->
                                            <div class="dropdown-container2">
                                                <button class="dropbtn w-60"
                                                    :style="getStatusStyle(getStatusText(project.info.subscriptionDate, project.info.subscriptionDuration))">
                                                    {{ getStatusText(project.info.subscriptionDate, project.info.subscriptionDuration) }}
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <!-- No Data Message -->
                                <!-- <div class="col" v-if="!data || !data.length">
                                    <p>No data</p>
                                </div> -->
                            </div>
                           
                        </div>
                        <!-- Filters Column -->
                        <div v-if="showFilters" class="col-md-3 rightCol">
                            <div class="card border-0 mb-2">
                                <div
                                    class="card-header mb-5 py-1 px-0 d-sm-flex align-items-center justify-content-between">
                                    <h3 class="fw-bold mb-0">Filters</h3>
                                    <div>
                                        <button type="button" class="ms-0 ms-sm-3 btn"
                                            style="color:var(--secondary-color); font-weight:bold"
                                            @click="createProject" v-if="canCreateProject || superUser">
                                            <i class="icofont-plus me-2 fs-6"></i>New Hosting
                                        </button>
                                    </div>
                                    <div class="ms-3 d-flex align-items-center">
                                        <i class="wx-ic wx-ic-list" v-if="isGridView" title="List" @click="isGridView = false"></i>
                                        <div v-if="!isGridView" class="wx-ic-on">
                                            <i class="wx-ic wx-ic-list" title="List" @click="isGridView = false"></i>
                                        </div>
                                        <i class="wx-ic wx-ic-grid" v-if="!isGridView" title="Grid" @click="isGridView = true"></i>
                                        <div v-if="isGridView" class="wx-ic-on">
                                            <i class="wx-ic wx-ic-grid" title="Grid" @click="isGridView = true"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="filter-section mt-3">

                                    <div class="d-flex align-items-center mb-3">
                                       
                                        <input id="main-search-input" type="search" class="form-control"
                                            placeholder="Αναζήτηση..." aria-label="search"
                                            aria-describedby="addon-wrapping" />
                                    </div>

                                    <div>
                                        <div class="card border-0 mb-2 no-bg">
                                            <div
                                                class="card-header py-1 px-0 d-sm-flex align-items-center justify-content-between main-button-area">
                                                <ul class="nav nav-tabs tab-body-header rounded mt-sm-0 mt-3 ms-0 ms-sm-3 prtab-set w-sm-100"
                                                    role="tablist">
                                                    <li class="nav-item col" v-for="status in statusFilters"
                                                        :key="status.id">
                                                        <a :class="statusClass(status.id)"
                                                            @click.prevent="applyStatusFilter(status.id)" href="#"
                                                            role="tab">{{
                                                                status.name }}</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <ul class="nav nav-tabs tab-body-header rounded w-100 mb-2" role="tablist">

                                            <li class="nav-item ">
                                                <a :class="{ 'nav-link text-center active': filters.statusId == '0' || filters.statusId == undefined, 'nav-link text-center': filters.statusId != '0' && filters.statusId != undefined }"
                                                    @click.prevent="() => updateFilters({ ...filters, statusId: '0', page: 1 })"
                                                    href="#" role="tab">
                                                    <p style="font-size: large;">All</p>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a :class="{ 'nav-link text-center active': filters.statusId == '1', 'nav-link text-center': filters.statusId != '1' }"
                                                    @click.prevent="() => updateFilters({ ...filters, statusId: '1', page: 1 })"
                                                    href="#" role="tab"> <span class="wx-st wx-st-hold" title="On Hold">On hold</span>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a :class="{ 'nav-link text-center active': filters.statusId == '2', 'nav-link text-center': filters.statusId != '2' }"
                                                    @click.prevent="() => updateFilters({ ...filters, statusId: '2', page: 1 })"
                                                    href="#" role="tab"> <span class="wx-st wx-st-progress" title="In Progress">In progress</span>

                                                </a>
                                            </li>
                                            <li class="nav-item ">
                                                <a :class="{ 'nav-link text-center active': filters.statusId == '3', 'nav-link text-center': filters.statusId != '3' }"
                                                    @click.prevent="() => updateFilters({ ...filters, statusId: '3', page: 1 })"
                                                    href="#" role="tab"> <span class="wx-st wx-st-done" title="Done">Done</span>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a :class="{ 'nav-link text-center active': filters.statusId == '5', 'nav-link text-center': filters.statusId != '5' }"
                                                    @click.prevent="() => updateFilters({ ...filters, statusId: '5', page: 1 })"
                                                    href="#" role="tab"><span class="wx-st wx-st-ongoing" title="On going">On going</span></a>
                                            </li>
                                            <li class="nav-item">
                                                <a :class="{ 'nav-link text-center active': filters.statusId == '4', 'nav-link text-center': filters.statusId != '4' }"
                                                    @click.prevent="() => updateFilters({ ...filters, statusId: '4', page: 1 })"
                                                    href="#" role="tab"> <span class="wx-st wx-st-archived" title="Archived">Archived</span>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a :class="{ 'nav-link text-center active': filters.statusId == '6', 'nav-link text-center': filters.statusId != '6' }"
                                                    @click.prevent="() => updateFilters({ ...filters, statusId: '6', page: 1 })"
                                                    href="#" role="tab"> <span class="wx-st wx-st-potential" title="Potential">Potential</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <!-- Date Filters -->
                                    <div class="mb-3 d-flex align-items-center">
                                        <label for="start-date" class="form-label me-2">Start date:</label>
                                        <input type="date" id="start-date" v-model="startDate"
                                            class="form-control w-auto" />
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label for="end-date" class="form-label me-2">End date:</label>
                                        <input type="date" id="end-date" v-model="endDate"
                                            class="form-control w-auto" />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Create Project-->
        <div class="modal fade" id="create-project-form" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title fw-bold" id="createprojectlLabel">Δημιουργία Hosting
                        </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
        <!-- Left Column -->
        <div class="col-md-6">
                        <div class="mb-3">
                            <label for="projectTitle" class="form-label" aria-label="Title"
                                aria-placeholder="Title">Title</label>
                            <input type="text" class="form-control" id="projectTitle" placeholder="Title" name="title"
                                v-model="projectData.title">
                        </div>
                        <div class="mb-3">
                            <label for="projectDescriptionTinyMce" class="form-label">Description</label>
                            <Editor api-key="no-api-key" :init="tinymceInit" v-model="projectData.body">
                            </Editor>
                        </div>
                    </div>

<!-- Right Column -->
<div class="col-md-6">
                        <div class="mb-3">
                            <label class="form-label">Client</label>
                            <Select2 :options="allData.clients" v-model="projectData.clientId"
                                :settings="select2Settings" />
                        </div>
                        <div class="mb-3" v-if="superUser || canEditProjectCreator">
                            <label class="form-label">Creator</label>
                            <Select2 :options="allData.users" v-model="projectData.createdBy"
                                :settings="select2SettingsProject" />
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Status</label>
                            <Select2 :options="allData.statuses" v-model="projectData.statusId"
                                :settings="select2Settings" />
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Services</label>
                            <Select2 :options="allData.services" v-model="projectData.serviceId"
                                :settings="select2Settings" />
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Manager</label>
                            <Select2 :options="allData.users" v-model="projectData.managerId"
                                :settings="select2Settings" />
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Assigned users</label>
                            <Select2 :options="allData.users" v-model="projectData.assignedUsers"
                                :settings="{ ...select2Settings, multiple: true }" />
                        </div>
                        <div class="mb-3">
                            <label for="projectEstimatedHours" class="form-label" aria-label="Estimated hours"
                                aria-placeholder="Estimated hours">Estimated hours</label>
                            <input type="number" class="form-control" id="projectEstimatedHours"
                                placeholder="Estimated hours" aria-label="Estimated hours"
                                aria-placeholder="Estimated hours" name="estimatedHours"
                                v-model="projectData.estimatedTime">
                        </div>
                        <div class="mb-3">
                <div class="row">

                        <div class="col">
                            <label for="projectStartDate" class="form-label">Start Date</label>
                            <input type="date" class="form-control" id="projectStartDate" name="startDate" v-model="projectData.startDate">
                        </div>
                        <div class="col">
                            <label for="projectEndDate" class="form-label">End Date</label>
                            <input type="date" class="form-control" id="projectEndDate" name="endDate" v-model="projectData.endDate">
                        </div>
                   
 </div>        </div>
</div></div>
                        <div class="mb-3 payable-container">
                            <div class="mb-3">
                                <label class="form-label">Payable</label>
                                <Select2
                                    :options="[{ id: '', text: 'Παρακαλώ επιλέξτε' }, { id: '0', text: 'No' }, { id: '1', text: 'Yes' }]"
                                    v-model="projectData.payable" :settings="select2Settings" />
                            </div>
                            <div class="payable-fields" v-if="projectData.payable == '1'">
                                <div class="mb-3">
                                    <label class="form-label">Pay Manager</label>
                                    <Select2 :options="allData.users" v-model="projectData.payManagerId"
                                        :settings="select2Settings" />
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Invoiced</label>
                                    <Select2
                                        :options="[{ id: '', text: 'Παρακαλώ επιλέξτε' }, { id: '0', text: 'No' }, { id: '1', text: 'Yes' }]"
                                        v-model="projectData.invoiced" :settings="select2Settings" />
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Paid</label>
                                    <Select2
                                        :options="[{ id: '', text: 'Παρακαλώ επιλέξτε' }, { id: '0', text: 'No' }, { id: '1', text: 'Yes' }]"
                                        v-model="projectData.paid" :settings="select2Settings" />
                                </div>
                            </div>
                        </div>
                       
                        <div class="mb-3">
                            <label for="subscriptionDate" class="form-label" aria-label="Subscription date"
                                aria-placeholder="Subscription date">Subscription date</label>
                            <input type="date" class="form-control" id="subscriptionDate"
                                placeholder="Subscription date" aria-label="Subscription date"
                                aria-placeholder="Subscription date" name="subscriptionDate"
                                v-model="projectData.subscriptionDate">
                        </div>
                        <div class="mb-3">
                            <label for="subscriptionDuration" class="form-label"
                                aria-label="Subscription duration (months)"
                                aria-placeholder="Subscription duration (months)">Subscription duration
                                (months)</label>
                            <input type="number" class="form-control" id="subscriptionDuration"
                                placeholder="Subscription duration (months)" aria-label="Subscription duration (months)"
                                aria-placeholder="Subscription duration (months)" name="subscriptionDuration"
                                v-model="projectData.subscriptionDuration">
                        </div>
                        <div id="create-project-errors"></div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click.prevent="submitForm">Create</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Confirmation Modal for Archiving Project -->
    <div class="modal fade" id="archive-confirmation-modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Confirm Archive</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    Are you sure you want to archive this project?
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-danger" @click="confirmArchive">Yes, Archive</button>
                </div>
            </div>
        </div>
    </div>
    <!-- Toggle Button -->
    <button class="btn btn-toggle-filter" @click="toggleFilters"
        style="position: fixed; right: 1em; top: 40vh; z-index: 1000; padding:10px; background-color: var(--secondary-color)">
        <i class="wx-ic wx-ic-filter" title="Toggle Filters"></i>
    </button>
</template>

<script>
import { editorSkin } from '@/wxHelpers';
import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
import { useFetchData } from '@/composables/useFetchData';
import { fetchAll, createOrUpdate, get, massArchiveProjects, getClientsServicesStatusesUsers } from '@/services/hosting';
import { useRoute, useRouter } from 'vue-router';
import { useToast } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import Editor from '@tinymce/tinymce-vue';
import Select2 from 'vue3-select2-component';
import { mapGetters } from 'vuex';
import { fetchManagers } from '@/services/followup';


const defaultProjectData = {
    title: '',
    description: '',
    clientId: '',
    assignedUsers: [],
    serviceId: '',
    managerId: '',
    statusId: '',
    payable: '0',
    payManagerId: '',
    invoiced: '0',
    paid: '1',
    estimatedTime: '',
    startDate: '',
    endDate: ''
};

export default {
    name: 'Projects',
    data() {
        return {
            isGridView: false, // true for grid view, false for list view
            showFilters: false,
            projectToArchive: null,
        };
    },
    methods: {
        toggleFilters() {
            this.showFilters = !this.showFilters; // Toggle the filter display
        },
        currentUserId(){
      return localStorage.getItem('current_user_id');
    },
        canEditProject(project) {
            if (!project) { return false; }
            return localStorage.getItem('current_user_id') == project.info?.createdBy && this.userPermissions?.edit === 1;
        },
        archiveProject(projectId) {
            this.projectToArchive = projectId;
            $("#archive-confirmation-modal").modal("show");
        },
        // Confirm archiving after user approval
        async confirmArchive() {
            if (this.projectToArchive) {
                const response = await massArchiveProjects({ ids: [this.projectToArchive] });
                if (response.data.success) {
                    useToast().success(response.data.message);
                    this.fetchData();
                } else {
                    useToast().error(response.data.message);
                }
                this.projectToArchive = null; // Reset after action
                $("#archive-confirmation-modal").modal('hide');
            }
        }
    },
    components: {
        Editor,
        Select2
    },
    computed: {
        ...mapGetters({
            getSuperUserPermission: 'getSuperUserPermission',
        }),

        canCreate() {
            return this.getSuperUserPermission === 1;
        },
        canUpdate() {
            return this.getUserPermission === 1;
        },
        canArchive() {
            return this.getSuperUserPermission === 1;
        },
        superUser() {
            return this.getSuperUserPermission === 1;
        },
    },
    setup() {
        const route = useRoute();
        const router = useRouter();

        const { data, paginationLinks, filters, updateFilters, fetchData, sortBy } = useFetchData(fetchAll, { page: route.query.page || 1, active: route.query.active || 1, archived: route.query.archived || 0, hosting: 1 }, { page: 1, active: 1, archived: 0, hosting: 1 });

        const projectData = ref(defaultProjectData);
        const allData = ref({});
        const selectedProjectIds = ref([]);
        const isDropdownOpen = ref(false);
        const isDropdownCreatorOpen = ref(false);
        const payableFieldsShow = ref(false);
        const searchArea = ref(route.query?.searchField || 'title');
        const startDate = ref(route.query?.startDate || '');
        const endDate = ref(route.query?.endDate || '');
        const statuses = ref([]);

        const managers = ref([]);
        const creators = ref([]);
const selectedManager = ref('');
        const selectedCreator = ref('');
        const managerSelect = ref(null);
        const transformDate = (dateStr) => {
            const [day, month, year] = dateStr.split('/');
            const formattedDate = `${year}-${month}-${day}`;
            return formattedDate;
        };

        // Watch for changes to startDate and endDate and update URL filters
        watch([searchArea], ([newSearchArea]) => {
            router.push({
                path: '/hosting',
                query: { ...route.query, searchField: newSearchArea },
            });
        });

        // Watch for changes to startDate and endDate and update URL filters
        watch([startDate, endDate], ([newStartDate, newEndDate]) => {
            router.push({
                path: '/hosting',
                query: { ...route.query, startDate: newStartDate, endDate: newEndDate },
            });
        });

        const toggleProjectSelection = (projectId, event) => {
            if (!selectedProjectIds.value.includes(projectId)) {
                selectedProjectIds.value.push(projectId);
            } else {
                selectedProjectIds.value = selectedProjectIds.value.filter(id => id !== projectId);
            }
        };

        const archiveProjects = async () => {
            if (!selectedProjectIds.value.length) {
                useToast().error('Δεν έχετε επιλέξει projects');
                return;
            }
            const response = await massArchiveProjects({ ids: selectedProjectIds.value });
            if (response.data.success) {
                useToast().success(response.data.message);
                fetchData();
            } else {
                useToast().error(response.data.message);
            }
        };

        const fetchManagersData = async () => {
            try {
                const response = await fetchManagers();
                if (response.data.success) {
                    managers.value = response.data.data;
                }
            } catch (error) {
                console.error('Failed to fetch managers:', error);
            }
        };

        const fetchCreatorsData = async () => {
            try {
                const response = await fetchManagers();
                if (response.data.success) {
                    creators.value = response.data.data;
                } else {
                    console.error("Failed to fetch creators:", response.data.message);
                }
            } catch (error) {
                console.error("Failed to fetch creators:", error);
            }
        };

        const editProject = async (id) => {
            const tmpAllData = await getClientsServicesStatusesUsers();
            let newData = { users: [], statuses: [], clients: [], services: [] };
            for (let i = 0; i < tmpAllData.data.users.length; i++) {
                newData.users.push({ id: tmpAllData.data.users[i].id, text: tmpAllData.data.users[i].username });
            }
            for (let i = 0; i < tmpAllData.data.statuses.length; i++) {
                newData.statuses.push({ id: tmpAllData.data.statuses[i].id, text: tmpAllData.data.statuses[i].description });
            }
            for (let i = 0; i < tmpAllData.data.clients.length; i++) {
                newData.clients.push({ id: tmpAllData.data.clients[i].id, text: tmpAllData.data.clients[i].title });
            }
            for (let i = 0; i < tmpAllData.data.services.length; i++) {
                newData.services.push({ id: tmpAllData.data.services[i].id, text: tmpAllData.data.services[i].title });
            }
            allData.value = newData;
            const projectInfo = await get({ "id": id });
            if (projectInfo.data.success) {
                projectData.value = {
                    ...projectInfo.data.data.info,
                    assignedUsers: projectInfo.data.data.assigned ? projectInfo.data.data.assigned?.map((assignedUser) => assignedUser.id) : [],
                    startDate: transformDate(projectInfo.data.data.info.startDate),
                    endDate: transformDate(projectInfo.data.data.info.endDate),
                };
            }
            $("#create-project-form").modal('toggle');
        };

        const createProject = async () => {
            const tmpAllData = await getClientsServicesStatusesUsers();
            let newData = { users: [], statuses: [], clients: [], services: [] };
            for (let i = 0; i < tmpAllData.data.users.length; i++) {
                newData.users.push({ id: tmpAllData.data.users[i].id, text: tmpAllData.data.users[i].username });
            }
            for (let i = 0; i < tmpAllData.data.statuses.length; i++) {
                newData.statuses.push({ id: tmpAllData.data.statuses[i].id, text: tmpAllData.data.statuses[i].description });
            }
            for (let i = 0; i < tmpAllData.data.clients.length; i++) {
                newData.clients.push({ id: tmpAllData.data.clients[i].id, text: tmpAllData.data.clients[i].title });
            }
            for (let i = 0; i < tmpAllData.data.services.length; i++) {
                newData.services.push({ id: tmpAllData.data.services[i].id, text: tmpAllData.data.services[i].title });
            }
            allData.value = newData;
            projectData.value = {
                title: '',
                description: '',
                body: '',
                clientId: '',
                assignedUsers: [],
                serviceId: '',
                managerId: '',
                statusId: '',
                payable: '0',
                payManagerId: '',
                invoiced: '0',
                paid: '1',
                estimatedTime: '',
                startDate: '',
                endDate: ''
            };
            $("#create-project-form").modal('toggle');
        };

        const submitForm = async () => {
            const response = await createOrUpdate(projectData.value);
            if (response.data.success) {
                useToast().success(response.data.message);
                $("#create-project-form").modal('toggle');
                fetchData();
            } else {
                useToast().error(response.data.message);
            }
        };

        const getPageFromUrl = (url) => {
            if (!url) return null;
            const urlObj = new URL(url, window.location.origin);
            return urlObj.searchParams.get('page');
        };

        const dropdownStyle = computed(() => ({
            top: isDropdownOpen.value ? '100%' : 'initial',
            right: isDropdownOpen.value ? '0' : 'initial'
        }));

         const toggleDropdown = () => {
            isDropdownOpen.value = !isDropdownOpen.value;
            isDropdownCreatorOpen.value = false;
        };

        const toggleDropdownCreator = () => {
            isDropdownCreatorOpen.value = !isDropdownCreatorOpen.value;
            isDropdownOpen.value = false;
        };

        // Function to handle manager selection
        const selectManager = (manager) => {
            selectedManager.value = manager.username;
            isDropdownOpen.value = false;  // Close the dropdown after selection
            updateManagerFilter(manager.id); // Call your update manager filter function
        };

        const selectCreator = (creator) => {
            selectedCreator.value = creator.username;
            isDropdownCreatorOpen.value = false;  // Close the dropdown after selection
            updateCreatorFilter(creator.id); // Call your update manager filter function
        };

        const closeDropdown = () => {
            isDropdownOpen.value = false;
        };

        const tinymceInit = {
            height: 500,
            license_key: 'gpl',
            ...editorSkin(),
        };

        const select2Settings = {
            dropdownParent: '#create-project-form .modal-content',
            placeholder: "Please select"
        };

        const updateManagerFilter = (managerId) => {
        // Now, managerId is passed directly from the selectManager method
        updateFilters({ ...filters.value, managerFilter: managerId, page: 1 });
        };

        const updateCreatorFilter = (creatorId) => {
            updateFilters({ ...filters.value, creatorFilter: creatorId, page: 1 });
        };

        const addMonths = (date, months) => {
            const newDate = new Date(date);  // Create a copy of the input date to avoid modifying the original
            newDate.setMonth(newDate.getMonth() + months);  // Add the specified number of months
            return newDate;
        };

        const getStatusText = (subscriptionDate, expiresInMonths) => {
            if (!subscriptionDate || !expiresInMonths) {
                return 'Active'; // If no subscription date, consider it active.
            }

            const now = new Date();
            let subDate = new Date(subscriptionDate);
            subDate = addMonths(subDate, expiresInMonths);
            const diffTime = Math.abs(subDate - now);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            if (subDate < now) {
                return 'Expired'; // If subscription date is in the past, it's expired.
            } else if (diffDays <= 15) {
                return 'Expires soon'; // If the subscription expires in 15 days or less.
            } else {
                return 'Active'; // If the subscription is still valid and more than 15 days away.
            }
        };


        const getStatusStyle = (statusText) => {
            if (statusText === 'Expires soon') {
                return {
                    'background': 'linear-gradient(to right, orange, rgb(222, 148, 11))',
                    'color': 'white',
                    'padding': '2px 8px',
                    'border-radius': '99px',
                    'font-size': 'smaller',
                    'font-weight': 'bold',
                    'white-space': 'nowrap',
                    'text-align': 'center',
                    'height': '30px'
                };
            } else if (statusText === 'Expired') {
                return {
                    'background': 'linear-gradient(to right, #fc1d1d, #820a0a)',
                    'color': 'white',
                    'padding': '2px 8px',
                    'border-radius': '99px',
                    'font-size': 'smaller',
                    'font-weight': 'bold',
                    'white-space': 'nowrap',
                    'text-align': 'center',
                    'height': '30px'
                };
            } else {
                return {
                    'background': 'linear-gradient(to right, green, #0d860d)',
                    'color': 'white',
                    'padding': '2px 8px',
                    'border-radius': '99px',
                    'font-size': 'smaller',
                    'font-weight': 'bold',
                    'white-space': 'nowrap',
                    'text-align': 'center',
                    'height': '30px'
                };
            }
        };

        const searchAction = () => {
            setTimeout(() => {
                router.push({ path: '/hosting', query: { ...route.query, search: $("#main-search-input").val(), searchArea: searchArea.value } });
            }, 300);
        };

        // Fetch data on component mount
        onMounted(async () => {
            const tmpAllData = await getClientsServicesStatusesUsers();
            fetchManagersData();
            fetchCreatorsData();
            let newData = { statuses: [] };
            for (let i = 0; i < tmpAllData.data.statuses.length; i++) {
                newData.statuses.push({ id: tmpAllData.data.statuses[i].id, description: tmpAllData.data.statuses[i].description });
            }
            statuses.value = newData.statuses;
            $(document.body).on('keyup', "#main-search-input", searchAction).on('click', "#main-search-input", searchAction);
        });

        onUnmounted(() => {
            $(document.body).off('keyup', "#main-search-input", searchAction).off('click', "#main-search-input", searchAction);
        });

        const getStatusIcon = (id) => {
            const status = statuses.value.find(s => s.id === id);
            return status ? status.icon : '';
        };

        const getCurrentStatus = (id) => {
            const status = statuses.value.find(s => s.id === id);
            return status ? status.description : 'Select Status';
        };

        return { getStatusIcon, getCurrentStatus, searchArea, startDate, endDate, data, allData, paginationLinks, filters, updateFilters, fetchData, getPageFromUrl, projectData, submitForm, editProject, createProject, selectedProjectIds, toggleProjectSelection, archiveProjects, toggleDropdown, getStatusStyle, updateManagerFilter, managers, updateCreatorFilter, creators, getStatusText, closeDropdown, isDropdownOpen, dropdownStyle, tinymceInit, select2Settings, sortBy, isDropdownOpen, selectManager, selectedManager, toggleDropdownCreator, selectCreator, isDropdownCreatorOpen, selectedCreator };
    },
    metaInfo: {
        title: 'Projects',
        meta: [
            { name: 'description', content: 'MIS - Projects' },
            { property: 'og:title', content: 'MIS - Projects' },
            { property: 'og:description', content: 'This is the projects page.' }
        ]
    }
};
</script>



<style scoped>
.checkbox-wrapper {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 1;
}

tr.selected,
div.selected {
    background: #b1afaf;
}

.card.selected-card {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.select2-container--default .select2-selection--single .select2-selection__rendered {
    line-height: 28px;
}

.select2-container--default .select2-selection--single .select2-selection__arrow {
    height: 28px;
}

.select2-container--default .select2-selection--single {
    height: 38px;
}

.select2-container--default .select2-selection--multiple .select2-selection__choice {
    background-color: #007bff;
    border-color: #007bff;
    color: #fff;
}

.select2-container .select2-selection--single {
    z-index: 9000;
    /* Adjust this value as necessary */
}

.select2-container .select2-selection--multiple {
    z-index: 9000;
    /* Adjust this value as necessary */
}

.select2-dropdown {
    z-index: 9000 !important;
    /* Ensure this is higher than other elements */
}
.leftCol {
    transition: width 0.3s ease-in-out;
}

.rightCol {
    transition: width 0.3s ease-in-out;
}

.modal.show .modal-dialog {
    z-index: 1050;
}

.modal-backdrop.show {
    z-index: 1040;
}
.dropdown-btn-filter {
    cursor: pointer;
    text-transform: capitalize;
    font-weight: 600;
    color: #545454;
}

.dropdown-btn {
    cursor: pointer;
}

/* Dropdown Options List */
.dropdown-options {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    border: 1px solid #dedede;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    z-index: 100;
    max-height: 200px;
    overflow-y: auto;
    width: 100%;
    list-style: none;
    padding: 0;
    margin: 0;
    min-width: 200px;
}

.dropdown-options-filters {
    position: absolute;
    border: 1px solid #dedede;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    z-index: 100;
    max-height: 200px;
    overflow-y: auto;
    width: fit-content;
    list-style: none;
    padding: 0;
    margin: 0;
    min-width: 200px;
}

.dropdown-options li,
.dropdown-options-filters li {
    padding: 10px 15px;
    cursor: pointer;
    font-size: 14px;
    color: #545454;
    font-weight: 600;
    border-bottom: 1px dashed lightgray;
}

.dropdown-options li:hover,
.dropdown-options-filters li:hover {
    background-color: #545454;
    color: white;
}
</style>
